import { Container, Stack, Title, Text, Button, Alert, Center, ThemeIcon, Group } from '@mantine/core';
import { IconX, IconArrowLeft, IconCreditCard } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

export const SubscriptionCanceledPage = () => {
  usePageTitle('Subscription Canceled | Meals You Love');
  const navigate = useNavigate();

  return (
    <Container size="sm" py="xl">
      <Stack gap="xl" align="center">
        <Center>
          <ThemeIcon size={80} radius="xl" variant="light" color="orange">
            <IconX size={40} />
          </ThemeIcon>
        </Center>

        <Stack gap="md" align="center">
          <Title order={1} ta="center">
            Subscription canceled
          </Title>
          <Text size="lg" c="dimmed" ta="center">
            You canceled the subscription process. No charges were made to your payment method.
          </Text>
        </Stack>

        <Alert variant="light" color="blue" w="100%" radius="lg">
          <Text size="sm">
            Your trial is still active! You can continue using Meals You Love and subscribe at any time before your trial expires.
          </Text>
        </Alert>

        <Group gap="md">
          <Button
            variant="outline"
            leftSection={<IconArrowLeft size={18} />}
            onClick={() => navigate('/')}
          >
            Back to Dashboard
          </Button>
          
          <Button
            leftSection={<IconCreditCard size={18} />}
            onClick={() => navigate('/billing')}
          >
            View Plans
          </Button>
        </Group>
      </Stack>
    </Container>
  );
};